module.exports = __webpack_public_path__ + "img/SKMJ_standard2.0cbff935.jpg";